/* Delta prototype styles. Logical properties throughout so one stylesheet serves LTR and RTL. */

@font-face { font-family: "Plex Arabic"; font-weight: 400; font-display: swap; src: url(fonts/plex-arabic-latin-400.woff2) format("woff2"); unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD; }
@font-face { font-family: "Plex Arabic"; font-weight: 500; font-display: swap; src: url(fonts/plex-arabic-latin-500.woff2) format("woff2"); unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD; }
@font-face { font-family: "Plex Arabic"; font-weight: 600; font-display: swap; src: url(fonts/plex-arabic-latin-600.woff2) format("woff2"); unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD; }
@font-face { font-family: "Plex Arabic"; font-weight: 700; font-display: swap; src: url(fonts/plex-arabic-latin-700.woff2) format("woff2"); unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD; }
@font-face { font-family: "Plex Arabic"; font-weight: 400; font-display: swap; src: url(fonts/plex-arabic-arabic-400.woff2) format("woff2"); unicode-range: U+0600-06FF, U+0750-077F, U+0870-088E, U+0890-0891, U+0897-08E1, U+08E3-08FF, U+200C-200E, U+2010-2011, U+204F, U+2E41, U+FB50-FDFF, U+FE70-FE74, U+FE76-FEFC; }
@font-face { font-family: "Plex Arabic"; font-weight: 500; font-display: swap; src: url(fonts/plex-arabic-arabic-500.woff2) format("woff2"); unicode-range: U+0600-06FF, U+0750-077F, U+0870-088E, U+0890-0891, U+0897-08E1, U+08E3-08FF, U+200C-200E, U+2010-2011, U+204F, U+2E41, U+FB50-FDFF, U+FE70-FE74, U+FE76-FEFC; }
@font-face { font-family: "Plex Arabic"; font-weight: 600; font-display: swap; src: url(fonts/plex-arabic-arabic-600.woff2) format("woff2"); unicode-range: U+0600-06FF, U+0750-077F, U+0870-088E, U+0890-0891, U+0897-08E1, U+08E3-08FF, U+200C-200E, U+2010-2011, U+204F, U+2E41, U+FB50-FDFF, U+FE70-FE74, U+FE76-FEFC; }
@font-face { font-family: "Plex Arabic"; font-weight: 700; font-display: swap; src: url(fonts/plex-arabic-arabic-700.woff2) format("woff2"); unicode-range: U+0600-06FF, U+0750-077F, U+0870-088E, U+0890-0891, U+0897-08E1, U+08E3-08FF, U+200C-200E, U+2010-2011, U+204F, U+2E41, U+FB50-FDFF, U+FE70-FE74, U+FE76-FEFC; }

:root {
  --navy-950: #040B1A;
  --navy-900: #07152D;
  --navy-800: #0C2142;
  --navy-700: #133160;
  --navy-600: #1E4783;
  --teal-700: #04598F;
  --teal-600: #0676B3;
  --teal-500: #1BA9E0;
  --teal-300: #7CD3F2;
  --teal-100: #D4EEFA;
  --teal-50: #EDF7FD;
  --blue-chart: #8FA6C8;

  --bg: #F4F6F9;
  --surface: #FFFFFF;
  --surface-2: #F8FAFC;
  --border: #E2E7EE;
  --border-strong: #CBD3DE;
  --ink: #0E1A2B;
  --ink-2: #3D4B5F;
  --muted: #677488;
  --faint: #98A3B3;

  --good: #12805C;   --good-bg: #E3F5EC;
  --warn: #9A6200;   --warn-bg: #FDF1D8;
  --bad: #B42318;    --bad-bg: #FDE7E5;

  --radius: 10px;
  --radius-sm: 7px;
  --shadow: 0 1px 2px rgba(14, 26, 43, .05), 0 1px 3px rgba(14, 26, 43, .06);
  --shadow-lg: 0 12px 32px rgba(7, 20, 39, .18);
  --sidebar-w: 264px;
  --rail-w: 72px;
  --topbar-h: 64px;

  color-scheme: light;
}

* { box-sizing: border-box; }
html, body { margin: 0; }
body {
  font-family: "Plex Arabic", system-ui, -apple-system, "Segoe UI", sans-serif;
  font-size: 14px;
  line-height: 1.5;
  color: var(--ink);
  background: var(--bg);
  -webkit-font-smoothing: antialiased;
}
[dir="rtl"] body { font-size: 14.5px; }
button, input, select, textarea { font: inherit; color: inherit; }
a { color: var(--teal-700); text-decoration: none; }
a:hover { text-decoration: underline; }
.num, .tabular { font-variant-numeric: tabular-nums; }
.num { direction: ltr; unicode-bidi: isolate; }
.sr-only { position: absolute; width: 1px; height: 1px; overflow: hidden; clip: rect(0 0 0 0); white-space: nowrap; }
svg.i { width: 18px; height: 18px; flex: none; stroke: currentColor; fill: none; stroke-width: 1.8; stroke-linecap: round; stroke-linejoin: round; }
[dir="rtl"] .flip { transform: scaleX(-1); }
:focus-visible { outline: 2px solid var(--teal-500); outline-offset: 2px; }

/* ---------- Buttons & form controls ---------- */
.btn {
  display: inline-flex; align-items: center; justify-content: center; gap: 8px;
  height: 38px; padding: 0 14px; border-radius: var(--radius-sm);
  border: 1px solid var(--border-strong); background: var(--surface); color: var(--ink);
  font-weight: 500; cursor: pointer; white-space: nowrap; text-decoration: none;
}
.btn:hover { background: var(--surface-2); text-decoration: none; }
.btn-primary { background: var(--teal-600); border-color: var(--teal-600); color: #fff; }
.btn-primary:hover { background: var(--teal-700); border-color: var(--teal-700); }
.btn-navy { background: var(--navy-900); border-color: var(--navy-900); color: #fff; }
.btn-navy:hover { background: var(--navy-800); }
.btn-ghost { border-color: transparent; background: transparent; }
.btn-ghost:hover { background: rgba(14, 26, 43, .05); }
.btn-sm { height: 32px; padding: 0 10px; font-size: 13px; }
.btn-icon { width: 38px; padding: 0; }
.btn-sm.btn-icon { width: 32px; }
.btn-danger-ghost { border-color: transparent; background: transparent; color: var(--muted); }
.btn-danger-ghost:hover { background: var(--bad-bg); color: var(--bad); }
.btn[disabled] { opacity: .45; cursor: not-allowed; }

.field { display: flex; flex-direction: column; gap: 6px; min-width: 0; }
.field > label, .label { font-size: 12.5px; font-weight: 500; color: var(--ink-2); }
.req::after { content: " *"; color: var(--bad); }
.control {
  height: 40px; width: 100%; padding: 0 12px; border-radius: var(--radius-sm);
  border: 1px solid var(--border-strong); background: var(--surface); outline: none;
  transition: border-color .12s, box-shadow .12s;
}
textarea.control { height: auto; min-height: 40px; padding-block: 9px; resize: vertical; }
.control:hover { border-color: #AEB9C7; }
.control:focus { border-color: var(--teal-600); box-shadow: 0 0 0 3px rgba(6, 118, 179, .15); }
select.control {
  appearance: none; padding-inline-end: 34px; cursor: pointer;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' stroke='%23677488' stroke-width='2' stroke-linecap='round' viewBox='0 0 24 24'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E");
  background-repeat: no-repeat; background-position: right 10px center;
}
[dir="rtl"] select.control { background-position: left 10px center; }
.input-group { position: relative; display: flex; align-items: center; }
.input-group > .control { padding-inline-start: 38px; }
.input-group > .lead { position: absolute; inset-inline-start: 11px; color: var(--muted); pointer-events: none; display: flex; }
.input-group > .trail { position: absolute; inset-inline-end: 6px; }
.input-group.has-trail > .control { padding-inline-end: 44px; }
.input-affix { display: flex; }
.input-affix .control { border-start-end-radius: 0; border-end-end-radius: 0; }
.input-affix .affix {
  display: flex; align-items: center; padding: 0 10px; border: 1px solid var(--border-strong); border-inline-start: 0;
  border-start-end-radius: var(--radius-sm); border-end-end-radius: var(--radius-sm); background: var(--surface-2); color: var(--muted); font-size: 13px;
}
.check { display: inline-flex; align-items: center; gap: 8px; cursor: pointer; user-select: none; }
.check input { width: 16px; height: 16px; accent-color: var(--teal-600); margin: 0; }
.hint { font-size: 12px; color: var(--muted); }

.segmented { display: inline-flex; padding: 3px; border-radius: 9px; background: #E9EDF2; gap: 2px; }
.segmented label { position: relative; }
.segmented input { position: absolute; opacity: 0; pointer-events: none; }
.segmented span {
  display: inline-flex; align-items: center; gap: 6px; height: 32px; padding: 0 12px; border-radius: 7px;
  font-size: 13px; font-weight: 500; color: var(--ink-2); cursor: pointer; white-space: nowrap;
}
.segmented input:checked + span { background: var(--surface); color: var(--ink); box-shadow: var(--shadow); }
.segmented input:focus-visible + span { outline: 2px solid var(--teal-500); }

.pill { display: inline-flex; align-items: center; gap: 6px; height: 24px; padding: 0 9px; border-radius: 99px; font-size: 12px; font-weight: 500; white-space: nowrap; }
.pill::before { content: ""; width: 6px; height: 6px; border-radius: 50%; background: currentColor; }
.pill.good { color: var(--good); background: var(--good-bg); }
.pill.warn { color: var(--warn); background: var(--warn-bg); }
.pill.bad { color: var(--bad); background: var(--bad-bg); }
.tag-proto {
  display: inline-flex; align-items: center; gap: 6px; padding: 3px 9px; border-radius: 6px;
  background: #FFF6E0; color: #7A4F00; border: 1px solid #F3DDA6; font-size: 11.5px; font-weight: 500;
}

/* ---------- Wordmark ---------- */
.wordmark { display: inline-flex; align-items: center; gap: 10px; color: inherit; text-decoration: none; }
.wordmark:hover { text-decoration: none; }
.wordmark .mark { width: 32px; height: 32px; flex: none; border-radius: 8px; object-fit: cover; }
.wordmark .wm-text { font-weight: 700; font-size: 20px; letter-spacing: .06em; line-height: 1; }
[dir="rtl"] .wordmark .wm-text { letter-spacing: 0; }
.wordmark .wm-text b { color: var(--teal-500); font-weight: 700; }
.wordmark .wm-sub { display: block; font-size: 10.5px; font-weight: 500; letter-spacing: .04em; opacity: .6; margin-top: 4px; text-transform: uppercase; }
[dir="rtl"] .wordmark .wm-sub { letter-spacing: 0; text-transform: none; }

/* ---------- Login ---------- */
.login { min-height: 100vh; display: grid; grid-template-columns: minmax(420px, 1fr) minmax(0, 1.1fr); background: var(--surface); }
/* The page fits a desktop window at 100% zoom (1280×720 and up, EN and AR, demo and signup shown): the spacing follows
   the window's height between a compact and the original size; the text keeps its size. Shorter windows, phones and
   enlarged zoom scroll as before (e2e/warehouses9zzb-login-fit.spec.ts). */
.login { --login-gap: clamp(10px, calc(3.3vh - 12px), 18px); }
.login-form-col { display: flex; flex-direction: column; padding: clamp(14px, calc(8vh - 40px), 32px) clamp(24px, 5vw, 72px); }
.login-head { display: flex; align-items: center; justify-content: space-between; gap: 12px; }
.login-body { flex: 1; display: flex; flex-direction: column; justify-content: center; width: 100%; max-width: 440px; margin: 0 auto; padding-block: clamp(6px, calc(14vh - 86px), 40px); }
.login-body h1 { font-size: 28px; line-height: 1.25; margin: 0 0 6px; letter-spacing: -.01em; }
.login-body .lede { color: var(--muted); margin: 0 0 clamp(14px, calc(6.7vh - 32px), 28px); }
.login-body form { display: flex; flex-direction: column; gap: var(--login-gap); }
.login-row { display: flex; align-items: center; justify-content: space-between; gap: 6px 12px; flex-wrap: wrap; }
.login-body .btn-primary { height: 44px; font-size: 15px; }
.login-alt { text-align: center; color: var(--muted); margin-top: calc(var(--login-gap, 18px) + 4px); }
/* Alerts on the sign-in page line up with the fields; the form's gap spaces them. */
.login-body .dlg-alert { margin: 0; }
.login-foot { display: flex; justify-content: space-between; gap: 12px; flex-wrap: wrap; color: var(--muted); font-size: 12.5px; }
.proto-note { margin-top: 18px; padding: 10px 12px; border-radius: var(--radius-sm); background: var(--surface-2); border: 1px dashed var(--border-strong); font-size: 12.5px; color: var(--ink-2); display: flex; gap: 8px; }
.proto-note svg { color: var(--teal-700); margin-top: 1px; }

.login-art {
  position: relative; overflow: hidden; color: #fff; padding: clamp(24px, calc(10vh - 40px), 48px) clamp(28px, 5vw, 64px);
  background:
    radial-gradient(900px 500px at 85% -10%, rgba(27, 169, 224, .35), transparent 60%),
    radial-gradient(700px 500px at -10% 110%, rgba(27, 169, 224, .18), transparent 60%),
    linear-gradient(160deg, var(--navy-800), var(--navy-950));
  display: flex; flex-direction: column; justify-content: space-between; gap: clamp(16px, calc(6vh - 20px), 32px);
}
.login-art .grid-bg { position: absolute; inset: 0; opacity: .08; background-image: linear-gradient(#fff 1px, transparent 1px), linear-gradient(90deg, #fff 1px, transparent 1px); background-size: 44px 44px; mask-image: linear-gradient(180deg, #000, transparent 85%); }
.login-art > * { position: relative; }
.login-art h2 { font-size: clamp(24px, 2.6vw, 34px); line-height: 1.25; margin: 0 0 12px; max-width: 520px; letter-spacing: -.01em; }
.login-art p { color: rgba(255, 255, 255, .72); max-width: 480px; margin: 0; }
.art-cards { display: grid; gap: 14px; max-width: 520px; }
.art-card { background: rgba(255, 255, 255, .07); border: 1px solid rgba(255, 255, 255, .12); border-radius: 14px; padding: 16px 18px; backdrop-filter: blur(6px); }
.art-card .k { font-size: 12.5px; color: rgba(255, 255, 255, .65); }
.art-card .v { font-size: 22px; font-weight: 600; margin-top: 2px; }
.art-row { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; }
.art-bars { display: flex; align-items: flex-end; gap: 6px; height: clamp(36px, calc(7.5vh - 14px), 54px); margin-top: 10px; }
.art-bars i { flex: 1; background: var(--teal-500); border-radius: 4px 4px 0 0; opacity: .9; }
.art-bars i:nth-child(odd) { opacity: .55; }
.art-points { display: flex; flex-wrap: wrap; gap: 8px 18px; color: rgba(255, 255, 255, .8); font-size: 13px; }
.art-points span { display: inline-flex; align-items: center; gap: 6px; }
.art-points svg { color: var(--teal-300); }

/* ---------- App shell ---------- */
.shell { display: grid; grid-template-columns: var(--sidebar-w) minmax(0, 1fr); min-height: 100vh; }
.sidebar { background: var(--navy-900); color: #C9D3E1; z-index: 40; }
.sb-inner { position: sticky; top: 0; height: 100vh; overflow: hidden; display: flex; flex-direction: column; }
.sb-head { display: flex; align-items: center; justify-content: space-between; height: var(--topbar-h); padding: 0 18px; color: #fff; border-bottom: 1px solid rgba(255, 255, 255, .06); flex: none; }
.sb-scroll { flex: 1; overflow-y: auto; padding: 14px 12px 20px; scrollbar-width: thin; scrollbar-color: rgba(255,255,255,.15) transparent; }
.sb-section { font-size: 11px; font-weight: 600; letter-spacing: .06em; text-transform: uppercase; color: #6F819C; padding: 14px 10px 6px; }
[dir="rtl"] .sb-section { letter-spacing: 0; }
.nav-item {
  display: flex; align-items: center; gap: 12px; width: 100%; height: 40px; padding: 0 10px; border-radius: 8px; border: 0;
  background: transparent; color: inherit; cursor: pointer; text-align: start; font-weight: 500; text-decoration: none;
}
.nav-item:hover { background: rgba(255, 255, 255, .06); color: #fff; text-decoration: none; }
.nav-item .lbl { flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.nav-item .chev { width: 16px; height: 16px; opacity: .6; transition: transform .15s; }
.nav-group.open > .nav-item .chev { transform: rotate(180deg); }
.nav-item.active { background: var(--teal-600); color: #fff; }
.nav-group.has-active > .nav-item { color: #fff; }
.nav-sub { display: none; margin: 2px 0 6px; padding-inline-start: 29px; position: relative; }
.nav-sub::before { content: ""; position: absolute; inset-inline-start: 19px; top: 4px; bottom: 4px; width: 1px; background: rgba(255, 255, 255, .12); }
.nav-group.open .nav-sub { display: block; }
.nav-sub a {
  display: flex; align-items: center; gap: 8px; height: 34px; padding: 0 10px; border-radius: 7px; color: #A9B6C9; font-size: 13.5px; text-decoration: none; position: relative;
}
.nav-sub a:hover { color: #fff; background: rgba(255, 255, 255, .05); text-decoration: none; }
.nav-sub a.active { color: #fff; background: rgba(27, 169, 224, .16); }
.nav-sub a.active::before { content: ""; position: absolute; inset-inline-start: -11px; top: 9px; bottom: 9px; width: 3px; border-radius: 3px; background: var(--teal-500); }
/* Hide / show the menu (correction pass of 29 Oct 2026, item 7). Wide screens only: the rail and drawer below 1200px. */
.sb-collapse { display: inline-flex; align-items: center; justify-content: center; width: 32px; height: 32px; border: 0; border-radius: 8px; background: transparent; color: #A9B6C9; cursor: pointer; flex: none; }
.sb-collapse:hover { background: rgba(255, 255, 255, .08); color: #fff; }
.sb-collapse:focus-visible, .sb-show:focus-visible { outline: 2px solid var(--teal-500); outline-offset: 2px; }
.topbar .sb-show { display: inline-flex; }
@media (min-width: 1200px) {
  .shell.sb-hidden { grid-template-columns: minmax(0, 1fr); }
  .shell.sb-hidden .sidebar { display: none; }
}
.sb-foot { flex: none; padding: 12px; border-top: 1px solid rgba(255, 255, 255, .06); }
.sb-plan { display: flex; align-items: center; gap: 10px; padding: 10px; border-radius: 10px; background: rgba(255, 255, 255, .05); font-size: 12.5px; }
.sb-plan b { color: #fff; font-weight: 600; display: block; }
.sb-plan .dot { width: 8px; height: 8px; border-radius: 50%; background: #F0B429; flex: none; }

.main { min-width: 0; display: flex; flex-direction: column; }
.topbar {
  position: sticky; top: 0; z-index: 30; height: var(--topbar-h); display: flex; align-items: center; gap: 12px;
  padding: 0 24px; background: rgba(255, 255, 255, .92); backdrop-filter: blur(8px); border-bottom: 1px solid var(--border);
}
.topbar .menu-btn { display: none; }
.tb-search { flex: 1; max-width: 420px; }
.tb-search .control { height: 38px; background: var(--surface-2); }
.tb-right { margin-inline-start: auto; display: flex; align-items: center; gap: 8px; }
.branch-select { display: flex; align-items: center; gap: 8px; height: 38px; padding-inline: 10px 4px; border: 1px solid var(--border-strong); border-radius: var(--radius-sm); background: var(--surface); }
.branch-select svg { color: var(--teal-700); }
.branch-select .bs-label { font-size: 12px; color: var(--muted); white-space: nowrap; }
.branch-select select { border: 0; height: 34px; padding-inline: 4px 28px; font-weight: 600; background-color: transparent; box-shadow: none; }
.branch-select select:focus { box-shadow: none; }
.lang-btn { font-weight: 600; }
.avatar { width: 34px; height: 34px; border-radius: 50%; display: grid; place-items: center; background: var(--teal-100); color: var(--teal-700); font-weight: 700; font-size: 13px; }
.user-btn { display: flex; align-items: center; gap: 10px; padding: 3px 8px 3px 3px; border-radius: 99px; border: 1px solid transparent; background: transparent; cursor: pointer; }
[dir="rtl"] .user-btn { padding: 3px 3px 3px 8px; }
.user-btn:hover { background: var(--surface-2); border-color: var(--border); }
.user-btn .u-name { font-weight: 600; font-size: 13px; line-height: 1.2; text-align: start; }
.user-btn .u-role { font-size: 11.5px; color: var(--muted); }
.menu-pop { position: absolute; top: calc(100% + 6px); inset-inline-end: 0; min-width: 200px; background: var(--surface); border: 1px solid var(--border); border-radius: 10px; box-shadow: var(--shadow-lg); padding: 6px; display: none; }
.menu-pop.open { display: block; }
.menu-pop button, .menu-pop a { display: flex; align-items: center; gap: 10px; width: 100%; padding: 9px 10px; border: 0; border-radius: 7px; background: transparent; cursor: pointer; color: var(--ink); text-decoration: none; }
.menu-pop button:hover, .menu-pop a:hover { background: var(--surface-2); text-decoration: none; }

.content { padding: 24px; max-width: 1480px; width: 100%; margin: 0 auto; }
.page-head { display: flex; align-items: flex-end; justify-content: space-between; gap: 16px; flex-wrap: wrap; margin-bottom: 20px; }
.crumbs { display: flex; align-items: center; gap: 6px; font-size: 12.5px; color: var(--muted); margin-bottom: 6px; flex-wrap: wrap; }
.crumbs a { color: var(--muted); }
.crumbs svg { width: 14px; height: 14px; }
.page-head h1 { font-size: 24px; line-height: 1.25; margin: 0; letter-spacing: -.01em; }
.page-head .sub { color: var(--muted); margin-top: 4px; }
.page-actions { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }

.card { background: var(--surface); border: 1px solid var(--border); border-radius: var(--radius); box-shadow: var(--shadow); }
.card-head { display: flex; align-items: center; justify-content: space-between; gap: 12px; padding: 16px 20px; border-bottom: 1px solid var(--border); flex-wrap: wrap; }
.card-head h2 { font-size: 15px; margin: 0; font-weight: 600; display: flex; align-items: center; gap: 8px; }
.card-head h2 .count { font-size: 12px; font-weight: 500; color: var(--muted); background: var(--surface-2); border: 1px solid var(--border); border-radius: 99px; padding: 1px 8px; }
.card-head .meta { font-size: 12.5px; color: var(--muted); }
.card-body { padding: 20px; }

/* ---------- Dashboard ---------- */
.kpis { display: grid; grid-template-columns: repeat(6, minmax(0, 1fr)); gap: 14px; margin-bottom: 18px; }
.kpi { padding: 16px; display: flex; flex-direction: column; gap: 10px; text-decoration: none; color: inherit; transition: border-color .12s, transform .12s; }
.kpi:hover { border-color: var(--teal-300); text-decoration: none; }
.kpi-top { display: flex; align-items: center; justify-content: space-between; gap: 8px; }
.kpi-ico { width: 34px; height: 34px; border-radius: 9px; display: grid; place-items: center; background: var(--teal-50); color: var(--teal-700); }
.kpi-ico.navy { background: #E8EDF5; color: var(--navy-700); }
.kpi-name { font-size: 13px; color: var(--ink-2); font-weight: 500; }
.kpi-count { font-size: 26px; font-weight: 700; line-height: 1.1; letter-spacing: -.01em; }
.kpi-amt { white-space: nowrap; font-size: 12.5px; color: var(--muted); }
.kpi-amt b { color: var(--ink-2); font-weight: 600; }
.kpi.featured { background: linear-gradient(150deg, var(--navy-800), var(--navy-950)); border-color: var(--navy-800); color: #fff; }
.kpi.featured .kpi-name, .kpi.featured .kpi-amt { color: rgba(255, 255, 255, .7); }
.kpi.featured .kpi-amt b { color: #fff; }
.kpi.featured .kpi-ico { background: rgba(27, 169, 224, .2); color: var(--teal-300); }
.kpi .delta { font-size: 12px; font-weight: 600; color: var(--good); }

.dash-grid { display: grid; grid-template-columns: minmax(0, 1.65fr) minmax(0, 1fr); gap: 18px; margin-bottom: 18px; }
.legend { display: flex; gap: 16px; font-size: 12.5px; color: var(--ink-2); }
.legend span { display: inline-flex; align-items: center; gap: 6px; }
.legend i { width: 10px; height: 10px; border-radius: 3px; display: inline-block; }
.chart-wrap { position: relative; }
.chart-wrap svg { display: block; width: 100%; height: auto; overflow: visible; }
.chart-wrap .axis text { fill: var(--muted); font-size: 11px; }
.chart-wrap .grid line { stroke: #EDF1F5; }
.chart-wrap .baseline { stroke: var(--border-strong); }
.chart-wrap .hit { fill: transparent; cursor: default; }
.chart-wrap .bar-g:hover .bar, .chart-wrap .bar-g.hover .bar { opacity: .85; }
.chart-wrap .bar-g.hover .hit { fill: rgba(14, 26, 43, .035); }
.tooltip {
  position: absolute; pointer-events: none; z-index: 5; min-width: 150px; background: var(--navy-950); color: #fff;
  border-radius: 8px; padding: 9px 11px; font-size: 12px; box-shadow: var(--shadow-lg); opacity: 0; transition: opacity .1s; transform: translate(-50%, calc(-100% - 10px));
}
.tooltip.show { opacity: 1; }
.tooltip .tt-title { font-weight: 600; margin-bottom: 4px; }
.tooltip .tt-row { display: flex; align-items: center; justify-content: space-between; gap: 14px; color: rgba(255, 255, 255, .8); }
.tooltip .tt-row i { width: 8px; height: 8px; border-radius: 2px; display: inline-block; margin-inline-end: 6px; }
.tooltip .tt-row b { color: #fff; font-weight: 600; }

.hbar-list { display: flex; flex-direction: column; gap: 14px; }
.hbar-row .hb-top { display: flex; justify-content: space-between; gap: 10px; font-size: 13px; margin-bottom: 6px; }
.hbar-row .hb-top span:first-child { color: var(--ink-2); }
.hbar-row .hb-top b { font-weight: 600; }
.hbar-track { height: 8px; border-radius: 99px; background: #EEF2F6; overflow: hidden; }
.hbar-fill { height: 100%; border-radius: 99px; background: var(--teal-600); }

.treasury-list { display: flex; flex-direction: column; }
.treasury-row { display: flex; align-items: center; gap: 12px; padding: 12px 0; border-bottom: 1px solid var(--border); }
.treasury-row:last-child { border-bottom: 0; }
.treasury-row .t-ico { width: 36px; height: 36px; border-radius: 9px; display: grid; place-items: center; background: #E8EDF5; color: var(--navy-700); flex: none; }
.treasury-row .t-name { font-weight: 500; }
.treasury-row .t-type { font-size: 12px; color: var(--muted); }
.treasury-row .t-amt { margin-inline-start: auto; font-weight: 600; }

.quick-actions { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px; }
.qa { display: flex; align-items: center; gap: 10px; padding: 12px; border-radius: 9px; border: 1px solid var(--border); background: var(--surface); color: var(--ink); font-weight: 500; text-decoration: none; cursor: pointer; text-align: start; }
.qa:hover { border-color: var(--teal-300); background: var(--teal-50); text-decoration: none; }
.qa .kpi-ico { width: 30px; height: 30px; }

/* ---------- Tables ---------- */
.table-wrap { overflow-x: auto; }
table.tbl { width: 100%; border-collapse: separate; border-spacing: 0; }
.tbl th {
  position: sticky; top: 0; background: var(--surface-2); color: var(--muted); font-size: 12px; font-weight: 600; text-align: start;
  padding: 10px 12px; border-bottom: 1px solid var(--border); white-space: nowrap;
}
.tbl td { white-space: nowrap; padding: 11px 12px; border-bottom: 1px solid var(--border); vertical-align: middle; }
.tbl tbody tr:hover td { background: #FAFCFD; }
.tbl tbody tr:last-child td { border-bottom: 0; }
.tbl .end { text-align: end; }
.tbl .muted { color: var(--muted); }
.tbl a.inv-no { font-weight: 600; color: var(--ink); }

/* ---------- Invoice editor ---------- */
.inv-stack { display: flex; flex-direction: column; gap: 18px; min-width: 0; }
.inv-bottom { display: grid; grid-template-columns: minmax(0, 1fr) 400px; gap: 18px; align-items: start; }
.inv-col { display: flex; flex-direction: column; gap: 18px; min-width: 0; }
.form-grid { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 16px 18px; }
.form-grid .span-2 { grid-column: span 2; }
.form-grid .span-3 { grid-column: span 3; }
.cust-row { display: flex; gap: 8px; }
.cust-row .control { flex: 1; }
.cust-info { display: flex; flex-wrap: wrap; gap: 6px 16px; font-size: 12px; color: var(--muted); margin-top: 2px; }
.cust-info b { color: var(--ink-2); font-weight: 500; }
.doc-no { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }
.doc-no .chip { font-size: 12.5px; padding: 4px 10px; border-radius: 99px; background: var(--surface); border: 1px solid var(--border); color: var(--ink-2); }
.doc-no .chip b { color: var(--ink); }

.lines-toolbar { display: flex; align-items: center; gap: 10px; padding: 12px 16px; border-bottom: 1px solid var(--border); flex-wrap: wrap; }
.lines-toolbar .barcode { flex: 1; min-width: 220px; max-width: 360px; }
.lines-toolbar .barcode .control { height: 36px; }
.lines-toolbar .spacer { flex: 1; }
.lines-table { min-width: 1060px; }
.lines-table th, .lines-table td { padding: 8px 8px; }
.lines-table th:first-child, .lines-table td:first-child { padding-inline-start: 16px; }
.lines-table th:last-child, .lines-table td:last-child { padding-inline-end: 12px; }
.lines-table td { border-bottom-color: #EDF1F5; }
.lines-table .control { height: 36px; padding: 0 9px; font-size: 13.5px; }
.lines-table select.control { padding-inline-end: 28px; background-position: right 7px center; }
[dir="rtl"] .lines-table select.control { background-position: left 7px center; }
.lines-table input[type=number] { text-align: end; font-variant-numeric: tabular-nums; }
.lines-table .w-idx { width: 30px; color: var(--muted); }
.lines-table .w-item { min-width: 200px; }
.lines-table .w-unit { width: 118px; }
.lines-table .w-qty { width: 80px; }
.lines-table .w-price { width: 104px; }
.lines-table .w-disc { width: 76px; }
.lines-table .w-tax { width: 120px; }
.lines-table .calc { text-align: end; white-space: nowrap; font-variant-numeric: tabular-nums; color: var(--ink-2); }
.lines-table .calc.total { color: var(--ink); font-weight: 600; }
.lines-table tr.selected td { background: var(--teal-50); }
.line-warn { display: flex; flex-wrap: wrap; gap: 4px; }
.line-warn:not(:empty) { margin-top: 5px; }
.line-warn .pill { height: 20px; font-size: 11px; padding: 0 7px; }
.item-sub { font-size: 11.5px; color: var(--muted); margin-top: 3px; display: flex; gap: 10px; }
.lines-foot { display: flex; align-items: center; justify-content: space-between; gap: 12px; padding: 10px 16px; border-top: 1px solid var(--border); background: var(--surface-2); border-end-start-radius: var(--radius); border-end-end-radius: var(--radius); font-size: 12.5px; color: var(--muted); flex-wrap: wrap; }
.empty { padding: 36px 16px; text-align: center; color: var(--muted); }
.empty svg { width: 34px; height: 34px; color: var(--faint); margin-bottom: 8px; }

.pay-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 16px 18px; }
.treasury-lines { display: flex; flex-direction: column; gap: 10px; }
.treasury-line { display: grid; grid-template-columns: minmax(0, 1fr) 160px 32px; gap: 8px; align-items: center; }

.dropzone {
  display: block; border: 1.5px dashed var(--border-strong); border-radius: var(--radius); padding: 22px; text-align: center; color: var(--muted); cursor: pointer; transition: border-color .12s, background .12s; background: var(--surface-2);
}
.dropzone:hover, .dropzone.drag { border-color: var(--teal-600); background: var(--teal-50); }
.dropzone svg { width: 26px; height: 26px; color: var(--teal-700); }
.dropzone b { color: var(--ink); display: block; margin: 6px 0 2px; font-weight: 600; }
.files { list-style: none; margin: 12px 0 0; padding: 0; display: flex; flex-direction: column; gap: 8px; }
.files li { display: flex; align-items: center; gap: 10px; padding: 8px 10px; border: 1px solid var(--border); border-radius: 8px; font-size: 13px; }
.files li .fname { flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.files li .fsize { color: var(--muted); font-size: 12px; }

.totals { padding: 6px 20px 18px; }
.totals .row { display: flex; justify-content: space-between; gap: 12px; padding: 9px 0; border-bottom: 1px dashed var(--border); font-size: 13.5px; }
.totals .row span:first-child { color: var(--ink-2); }
.totals .row .num { font-weight: 500; }
.totals .row.discount .num { color: var(--bad); }
.totals .grand { display: flex; justify-content: space-between; align-items: baseline; gap: 12px; padding: 14px 0 10px; border-bottom: 0; }
.totals .grand span:first-child { font-weight: 600; font-size: 15px; }
.totals .grand .num { font-size: 26px; font-weight: 700; letter-spacing: -.01em; }
.totals .cur { font-size: 12px; color: var(--muted); font-weight: 500; margin-inline-start: 4px; }
.totals .paid-box { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; margin-top: 4px; }
.totals .paid-box > div { padding: 10px 12px; border-radius: 9px; background: var(--surface-2); border: 1px solid var(--border); }
.totals .paid-box .k { font-size: 12px; color: var(--muted); }
.totals .paid-box .v { font-weight: 700; font-size: 16px; }
.totals .paid-box .rem.zero .v { color: var(--good); }
.totals .paid-box .rem.due .v { color: var(--warn); }
.assume { margin: 0 20px 18px; padding: 10px 12px; border-radius: 8px; background: #FFF8E6; border: 1px solid #F3DDA6; color: #6B4A00; font-size: 12px; display: flex; gap: 8px; }
.assume svg { flex: none; width: 16px; height: 16px; margin-top: 1px; }
.assume-inline { display: inline-flex; align-items: center; gap: 4px; font-size: 11.5px; color: #7A4F00; }
.assume-inline svg { width: 13px; height: 13px; }

.print-opts { display: flex; flex-direction: column; gap: 14px; }
.radio-cards { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 8px; }
.radio-card { position: relative; }
.radio-card input { position: absolute; opacity: 0; }
.radio-card span { display: flex; flex-direction: column; align-items: center; gap: 4px; padding: 10px 6px; border: 1px solid var(--border-strong); border-radius: 9px; cursor: pointer; font-size: 12.5px; font-weight: 500; text-align: center; color: var(--ink-2); }
.radio-card span svg { width: 20px; height: 20px; color: var(--muted); }
.radio-card input:checked + span { border-color: var(--teal-600); background: var(--teal-50); color: var(--ink); box-shadow: 0 0 0 1px var(--teal-600) inset; }
.radio-card input:checked + span svg { color: var(--teal-700); }
.radio-card input:focus-visible + span { outline: 2px solid var(--teal-500); outline-offset: 2px; }

.action-bar {
  position: sticky; bottom: 0; z-index: 20; display: flex; align-items: center; justify-content: space-between; gap: 16px;
  padding: 12px 24px; background: var(--navy-900); color: #fff; box-shadow: 0 -6px 20px rgba(7, 20, 39, .12);
}
.ab-stats { display: flex; align-items: center; gap: 28px; min-width: 0; }
.ab-stats .k { font-size: 11.5px; color: rgba(255, 255, 255, .62); }
.ab-stats .v { font-weight: 600; font-size: 15px; }
.ab-grand { padding-inline-start: 28px; border-inline-start: 1px solid rgba(255, 255, 255, .14); }
.ab-grand .v { font-size: 22px; font-weight: 700; }
.ab-grand .cur { font-size: 12px; color: rgba(255, 255, 255, .62); font-weight: 500; }
.ab-actions { display: flex; gap: 10px; }
.ab-actions .btn:not(.btn-primary) { background: transparent; color: #fff; border-color: rgba(255, 255, 255, .25); }
.ab-actions .btn:not(.btn-primary):hover { background: rgba(255, 255, 255, .08); }

/* ---------- Modal & toast ---------- */
.modal-back { position: fixed; inset: 0; background: rgba(7, 20, 39, .45); display: none; align-items: center; justify-content: center; padding: 20px; z-index: 100; }
.modal-back.open { display: flex; }
.modal { width: 100%; max-width: 520px; background: var(--surface); border-radius: 14px; box-shadow: var(--shadow-lg); }
.modal-head { display: flex; align-items: center; justify-content: space-between; padding: 16px 20px; border-bottom: 1px solid var(--border); }
.modal-head h3 { margin: 0; font-size: 16px; }
.modal-body { padding: 20px; display: grid; grid-template-columns: 1fr 1fr; gap: 14px 16px; }
.modal-body .full { grid-column: 1 / -1; }
.modal-foot { display: flex; justify-content: flex-end; gap: 10px; padding: 14px 20px; border-top: 1px solid var(--border); background: var(--surface-2); border-radius: 0 0 14px 14px; }
.toast-host { position: fixed; bottom: 22px; inset-inline-end: 22px; display: flex; flex-direction: column; gap: 10px; z-index: 200; }
.toast { display: flex; gap: 10px; align-items: flex-start; max-width: 380px; padding: 12px 14px; border-radius: 10px; background: var(--navy-950); color: #fff; box-shadow: var(--shadow-lg); font-size: 13px; animation: tin .18s ease-out; }
.toast svg { color: var(--teal-300); margin-top: 1px; }
@keyframes tin { from { opacity: 0; transform: translateY(8px); } }

.placeholder { text-align: center; padding: 64px 24px; }
.placeholder .kpi-ico { width: 52px; height: 52px; margin: 0 auto 14px; border-radius: 14px; }
.placeholder .kpi-ico svg { width: 26px; height: 26px; }
.placeholder h2 { margin: 0 0 6px; font-size: 20px; }
.placeholder p { color: var(--muted); max-width: 460px; margin: 0 auto 18px; }
.placeholder code { background: var(--surface-2); border: 1px solid var(--border); padding: 2px 6px; border-radius: 5px; font-size: 12.5px; direction: ltr; unicode-bidi: isolate; }

.scrim { display: none; }

/* ---------- Responsive ---------- */
@media (max-width: 1360px) {
  .kpis { grid-template-columns: repeat(3, minmax(0, 1fr)); }
}
@media (max-width: 1199px) {
  .shell { grid-template-columns: var(--rail-w) minmax(0, 1fr); }
  .sidebar { width: var(--rail-w); transition: width .18s ease; }
  .sidebar .nav-group.open .nav-sub { display: none; }
  .lines-table { min-width: 0; }
  .lines-table .col-net, .lines-table .w-idx { display: none; }
  .lines-table .w-item { min-width: 150px; }
  .lines-table .w-unit { width: 100px; }
  .lines-table .w-tax { width: 104px; }
  .lines-table th, .lines-table td { padding-inline: 5px; }
  .sidebar .lbl, .sidebar .chev, .sidebar .sb-section, .sidebar .nav-sub, .sidebar .wm-text, .sidebar .wm-sub, .sidebar .sb-plan div, .sidebar .sb-collapse { display: none; }
  .sidebar .sb-head { justify-content: center; padding: 0; }
  .sidebar .nav-item { justify-content: center; padding: 0; }
  .sidebar .sb-plan { justify-content: center; }
  .shell.drawer-open .sidebar { position: fixed; inset-block: 0; inset-inline-start: 0; width: var(--sidebar-w); box-shadow: var(--shadow-lg); }
  .shell.drawer-open .sidebar .lbl, .shell.drawer-open .sidebar .chev, .shell.drawer-open .sidebar .wm-text, .shell.drawer-open .sidebar .sb-plan div { display: initial; }
  .shell.drawer-open .sidebar .wm-sub { display: block; }
  .shell.drawer-open .main { grid-column: 2; }
  .shell.drawer-open .sidebar .sb-section { display: block; }
  .shell.drawer-open .sidebar .nav-group.open .nav-sub { display: block; }
  .shell.drawer-open .sidebar .sb-head { justify-content: space-between; padding: 0 18px; }
  .shell.drawer-open .sidebar .nav-item { justify-content: flex-start; padding: 0 10px; }
  .shell.drawer-open .sidebar .sb-plan { justify-content: flex-start; }
  .topbar .sb-show { display: none; }
  .shell.drawer-open .sidebar .sb-collapse { display: inline-flex; }
  .shell.drawer-open .scrim { display: block; position: fixed; inset: 0; background: rgba(7, 20, 39, .35); z-index: 35; }
  .topbar .menu-btn { display: inline-flex; }
  .topbar { padding: 0 18px; }
  .tb-search { display: none; }
  .user-btn .u-meta { display: none; }
  .content { padding: 20px 18px; }
  .dash-grid { grid-template-columns: minmax(0, 1fr); }
  .inv-bottom { grid-template-columns: minmax(0, 1fr) minmax(0, 1fr); }
  .form-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .form-grid .span-3 { grid-column: 1 / -1; }
  .action-bar { padding: 12px 18px; }
  .ab-stats { gap: 20px; }
  .ab-grand { padding-inline-start: 20px; }
  .login { grid-template-columns: minmax(0, 1fr); }
  .login-art { display: none; }
  .login-form-col { min-height: 100vh; background:
    radial-gradient(600px 300px at 100% 0, rgba(27, 169, 224, .10), transparent 70%), var(--surface); }
}
@media (max-width: 860px) {
  .kpis { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .inv-bottom { grid-template-columns: minmax(0, 1fr); }
  .ab-hide, .ab-actions .btn:not(.btn-primary) { display: none; }
  .branch-select .bs-label { display: none; }
  .page-head .page-actions { width: 100%; }
}
@media (max-width: 600px) {
  .form-grid { grid-template-columns: minmax(0, 1fr); }
  .form-grid .span-2, .form-grid .span-3 { grid-column: auto; }
  .pay-grid { grid-template-columns: minmax(0, 1fr); }
  .modal-body { grid-template-columns: 1fr; }
  .quick-actions { grid-template-columns: 1fr; }
  .treasury-line { grid-template-columns: minmax(0, 1fr) 120px 32px; }
  /* The top bar fits a phone (item 7 check at 390px): the environment tag keeps its icon and title, the branch picker narrows. */
  .topbar { padding: 0 10px; gap: 6px; }
  .tb-right { gap: 4px; min-width: 0; }
  .demo-badge > span { display: none; }
  .branch-select { min-width: 0; padding-inline: 6px 2px; gap: 4px; }
  .branch-select .control { min-width: 76px; max-width: 112px; padding-inline: 4px 22px; }
  .topbar .btn-ghost.btn-icon:not(.menu-btn) { width: 32px; }
  .lang-btn { padding-inline: 6px; }
}

@media print {
  .sidebar, .topbar, .action-bar, .toast-host { display: none !important; }
  .shell { display: block; }
}

.login-dest { width: 100%; }
.login-dest label { flex: 1; }
.login-dest span { justify-content: center; width: 100%; }
.login-dest svg { width: 16px; height: 16px; }

/* Try a demo account (migration 055): the banner on every screen, the sign-in button, and the print watermark. */
.demo-banner { position: sticky; top: 0; z-index: 1000; display: flex; flex-wrap: wrap; gap: 8px 10px; align-items: center; background: #fff4d6; color: #5a3d00; border-bottom: 1px solid #e8c770; padding: 6px 16px; font-size: 13px; }
.demo-banner-actions { margin-inline-start: auto; display: flex; gap: 12px; align-items: center; }
.demo-banner a { color: inherit; font-weight: 600; }
.demo-start { margin-top: var(--login-gap, 18px); display: grid; gap: 6px; }
.demo-start .btn { width: 100%; justify-content: center; }
.demo-start .login-alt { margin-top: 0; }
.demo-lock { margin-bottom: 12px; }
@media print {
  .demo-banner { display: none !important; }
  body.is-demo::after { content: "DEMO \00B7 NOT A TAX INVOICE"; position: fixed; top: 45%; left: 0; right: 0; text-align: center; font: 700 34pt sans-serif; color: #000; opacity: .12; transform: rotate(-18deg); pointer-events: none; }
}
